'use strict';
angular.module('schoolLinqApp').directive('csvReader', function () {
	return {
		scope: {
			csvReader: '=',
			readerType: '@',
			filename: '=',
		},
		link: function (scope, element) {
			$(element).on('change', function (changeEvent) {
				var files = changeEvent.target.files;
				if (files.length) {
					var r = new FileReader();
					if (files[0]) {
						scope.filename = files[0].name;
					}
					r.onload = function (e) {
						var values = [];
						var csvFile = e.target.result;
						var lines = csvFile.split('\n');
						var start = 1; // don't process the header line
						if (scope.readerType === 'UID') {
							// the UID file has no header line
							start = 0;
						}
						for (var i = start; i < lines.length; i++) {
							var data = lines[i].split(',');
							if (data[0]) {
								if (scope.readerType === 'Budget') {
									values.push({
										AccountNumber: data[0],
										Amount: data[1],
									});
								} else if (scope.readerType === 'Journal') {
									values.push({
										AccountNumber: data[0],
										Description: data[1],
										DebitAmount: Number(data[2]),
										CreditAmount: Number(data[3]),
									});
								} else if (scope.readerType === 'UID') {
									values.push({
										StaffNumber: data[0],
										DistrictCode: data[2],
										EmployeeNumber: data[9],
									});
								} else if (scope.readerType === 'ACH') {
									values.push({
										ReferenceNumber: data[0],
										SiteCode: data[1],
										OriginalAccountNumber: data[2],
										AccountNumber: data[2],
										AccountDescription: data[3],
										DepositDT: data[4],
										Amount: data[5],
									});
								}
							}
						}

						scope.$apply(function () {
							scope.csvReader = values;
						});
					};

					r.readAsText(files[0]);
				}
			});
		},
	};
});
